import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding-left: var(--container-padding);
  padding-right: var(--container-padding);
  border-top: ${(p) => (p.border ? `1px solid var(--gray-200)` : "none")};

  @media (max-width: 1200px) {
    max-width: calc(100% - var(--space-16));
    padding-left: var(--space-8);
    padding-right: var(--space-8);
  }

  @media (max-width: 768px) {
    max-width: calc(100% - var(--space-8));
    padding-left: var(--space-6);
    padding-right: var(--space-6);
  }

  @media (max-width: 480px) {
    max-width: 100%;
    padding-left: var(--space-4);
    padding-right: var(--space-4);
  }
`;
